import IAction from "../../types/IAction";
import { OBNotificationData } from "../../types/OBTypes";
import actionTypes from "../actionTypes";

export interface PickOBNotification {
  notification: OBNotificationData;
}

interface State extends PickOBNotification {
  title: string;
  subTitle: string;
}

const initialState: State = {
  notification: null,
  title: "",
  subTitle: ""
};

export default function conveniosReducer(
  state: State = initialState,
  action: IAction
): State {
  const snapshot = snapshotAction(state, action);

  // Llamada a resolver de snapshot
  state != snapshot &&
    !action.type.endsWith("_PENDING") &&
    action.meta &&
    action.meta.resolver &&
    action.meta.resolver({
      fulfilled: action.type.endsWith("_FULFILLED"),
      ...snapshot
    });

  return state != snapshot
    ? {
        ...state,
        ...snapshot
      }
    : state;
}

function snapshotAction(state: State = initialState, action: IAction) {
  switch (action.type) {
    case actionTypes.PICK_ONBOARDING_NOTIFICATION: {
      return {
        notification: action.payload
      };
    }
    case actionTypes.PICK_ONBOARDING_TITLE: {
      return {
        title: action.payload
      };
    }
    case actionTypes.PICK_ONBOARDING_SUBTITLE: {
      return {
        subTitle: action.payload
      };
    }

    default: {
      return state;
    }
  }
}
